module.exports = __webpack_public_path__ + "img/dracula-16.291f2d14.jpg";